import * as React from 'react';

import { SelectFormGroup, SelectFormGroupProps } from '@admin/components/fields/select_form_group';
import { client } from '@admin/libraries/apollo';
import { useWarehousesSelectorQuery, type Warehouse } from '@admin/schema';

const DEFAULT_FILTERS = { active: true };

export type WarehouseSelectFormGroupProps = Omit<SelectFormGroupProps, 'children' | 'value' | 'onChange'> & {
  placeholder?: string;
  value?: string;
  excludeIDs?: string[];
  onChange(value?: Warehouse['id']): void;
};

export const WarehouseSelectFormGroup: React.FC<WarehouseSelectFormGroupProps> = ({
  placeholder = '- Warehouse -',
  disabled,
  value,
  excludeIDs,
  onChange,
  ...props
}) => {
  const { data, loading } = useWarehousesSelectorQuery({ client, variables: { filters: DEFAULT_FILTERS } });
  const warehouses = (data?.warehouses ?? []).filter((warehouse) => !excludeIDs?.includes(warehouse.id));

  return (
    <SelectFormGroup
      disabled={disabled || loading}
      {...props}
      value={value ?? ''}
      onChange={(event) => onChange((event.target.value || undefined) as Warehouse['id'] | undefined)}
    >
      <option value="">{placeholder}</option>
      {warehouses.map((warehouse) => (
        <option key={warehouse.id} value={warehouse.id}>
          {warehouse.name}
        </option>
      ))}
    </SelectFormGroup>
  );
};
